<!--
 * @des: 获取小程序URL Scheme
 * @Author: zhc
 * @Date: 2022-06-257 14:55:54
-->
<template>
  <div class="pages"></div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { getScheme, getAppletParams } from '@/api'
export default {
  name: 'WxXcxSchemeLink',
  data() {
    return {
      COM_HTTP: getScheme,
    }
  },
  computed: {
    isWxEnv() {
      // 是否电脑微信或者微信开发者工具企业微信
      return /MicroMessenger/.test(window.navigator.userAgent)
    },
    isAliPayEnv() {
      return /AlipayClient/.test(window.navigator.userAgent)
    },
  },
  created() {},
  mounted() {
    // path默认寄件页
    const { query } = this.$route
    if (query && query.path) {
      if (this.isAliPayEnv) {
        this.zfbScheme(query)
      } else { // 微信跳转
        this.getScheme(query)
      }
    }
  },
  methods: {
    zfbScheme(query) {
      const { path } = query
      const objectToQueryString = this.objectToQueryString(query)
      const scheme = `alipays://platformapi/startapp?appId=2021003120640179&page=${path}&query=${encodeURIComponent(objectToQueryString)}`
      window.location.href = `https://ds.alipay.com/?scheme=${encodeURIComponent(scheme)}`
    },
    // 请求小程序链接
    async getScheme(query) {
      try {
        let { path } = query
        // path首个字符串不是/开头，则添加/
        if (!(path && path.startsWith('/'))) {
          path = '/' + path
        }
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        })
        const objectToQueryString = this.objectToQueryString(query)
        const { VUE_APP_ENV } = process.env
        const params = {
          path,
          queryParams: encodeURIComponent(objectToQueryString),
          version: VUE_APP_ENV === 'uat' ? 'trial' : '',
        }
        const { code, msg, data } = await this.COM_HTTP.getSchemeUrl2(params)
        this.$toast.clear()
        if (code === 1) {
          window.location.href = data // 页面重定向新的地址
          this.immediateCouponCollection()
        } else {
          alert(msg)
        }
      } catch (err) {
        console.log('🚀 ~ getScheme ~ err:', err)
        this.$toast.clear()
      }
    },
    // 使用微信js-sdk关闭当前h5页面
    async immediateCouponCollection () {
      const WX_LINK = window.location.href
      const { code, data } = await getAppletParams.getAppletParams(WX_LINK)
      if (code === 1) {
        wx.config({
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['closeWindow'],
        })
        // 通过ready接口处理成功验证
        wx.ready(function () {
          wx.closeWindow()
        })
      }
    },
    objectToQueryString(obj) {
      const params = new URLSearchParams()
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          params.append(key, obj[key])
        }
      }
      return params.toString()
    },
  },
}
</script>
